// extracted by mini-css-extract-plugin
export default {"StopCard":"StopCard_StopCard__wJUQF"};